import moment from 'moment';
import * as R from 'ramda';

import { Locale } from 'ha/i18n/types';
import { ISODate } from './types';

// ISODate :: String
// @link: https://en.wikipedia.org/wiki/ISO_8601

// YYYY-MM-DDThh:mm:ss.sssZ :: "2017-08-16T19:49:50.940Z"
// YYYY-MM-DD               :: "2017-08-16"

const fromNow = (locale: Locale = Locale.en, isoDate: ISODate) =>
  moment(isoDate).locale(locale).fromNow();

export default R.curryN(2, fromNow);
